import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelReturn: {
    defaultMessage: 'Cancel Return',
    description: 'Text for a button to cancel the return that is currently being created',
    id: 'ta3UrO',
  },
  internationalReturn: {
    defaultMessage: 'Edit Ship From address to create a domestic return label. International returns are not yet supported.',
    description: 'Error message for international returns',
    id: 'r55Wsn',
  },
});
